import React from "react";
import {
    Navigate,
    Outlet,
} from "react-router-dom";

export default function PublicRoute() {

    const token =
        localStorage.getItem("accessToken");

    const userData = JSON.parse(
        localStorage.getItem("user")
    );

    const role =
        userData?.user?.role;

    // Already logged in
    if (token) {

        if (role === "admin") {
            return (
                <Navigate
                    to="/admin/home"
                    replace
                />
            );
        }

        if (role === "user") {
            return (
                <Navigate
                    to="/user/home"
                    replace
                />
            );
        }
    }

    return <Outlet />;
}